import React, { ChangeEvent, KeyboardEvent, FC } from 'react';
import { useDispatch } from 'react-redux';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import { Dispatch } from '../../../../config/Store';
import ChatResourceItem from '../../ChatResourceItem';
import { colors } from '../../../../themes/colors';
import { ResourceToAdd } from '../../../../models/Chat';
import { TEXT_AREA_MARGIN_SPACING } from '../constants';
import { TestID } from './constants';

type Props = {
  chatMessage: string;
  onChange: (ev: ChangeEvent<HTMLInputElement>) => void;
  onKeyPress: (ev: KeyboardEvent) => void;
  resourcesToAdd: ResourceToAdd[];
} & WithStyles;

const styles = (theme) =>
  createStyles({
    resourceContainer: {
      overflowY: 'auto',
      maxHeight: 120,
      width: '100%',
    },
    textField: {
      marginLeft: TEXT_AREA_MARGIN_SPACING,
      marginRight: TEXT_AREA_MARGIN_SPACING,
      width: '100%',
      zIndex: 2,
      '& .MuiInputLabel-outlined': {
        backgroundColor: colors.white1,
        paddingRight: 4,
      },
    },
    textFieldInput: {
      ...theme.typography.body1,
      ...theme.overrides.MuiTypography.body1,
      color: colors.gray5,
      flexDirection: 'column',
    },
  });

const ChatInputFormTextField: FC<Props & { ref?: React.Ref<HTMLInputElement> }> = React.forwardRef(
  ({ chatMessage, classes, onChange, onKeyPress, resourcesToAdd }, ref) => {
    const dispatch = useDispatch<Dispatch>();

    const inputProps = {
      className: classes.textFieldInput,
      endAdornment: (
        <div className={classes.resourceContainer}>
          {resourcesToAdd.map((resourceToAdd) => (
            <ChatResourceItem
              item={resourceToAdd}
              key={resourceToAdd.uniqueKey}
              maxWidth
              noClick
              removeResource={dispatch.resources.toggleResource}
              useMargin
            />
          ))}
        </div>
      ),
      onKeyUp: onKeyPress,
    };

    return (
      <TextField
        className={classes.textField}
        id="message"
        inputProps={{ 'data-testid': TestID }}
        InputProps={inputProps}
        inputRef={ref}
        label="Write something here..."
        margin="normal"
        multiline
        name="message"
        onChange={onChange}
        rows={3}
        value={chatMessage}
        variant="outlined"
      />
    );
  },
);

export default withStyles(styles)(ChatInputFormTextField);
